export const SHADOW_RATE_FAQ_URL =
  'https://optiwatt.zendesk.com/hc/en-us/articles/52181924438043-Why-your-charging-schedule-may-shift-during-a-program'
